import { create } from "zustand";
import { v4 as uuidv4 } from "uuid";
import { filterSerializable } from "@/utils/utils";
import { useIframePoolStore } from "@/components/Canvas/IframePool/iframePoolStore";

export enum IFRAME_STATE {
  LOADING = "LOADING",
  SHOWING = "SHOWING",
  HIDDEN = "HIDDEN",
}

export interface IFrameMessage {
  id: string;
  type: string;
  payload: any;
}

interface IframeStore {
  // Single port for the main tempobook iframe
  iframeMessagingPort: MessagePort | null;
  setIframeMessagingPort: (port: MessagePort | null) => void;

  // Ports for application storyboard iframes (keyed by iframeId)
  applicationStoryboardPorts: { [iframeId: string]: MessagePort };
  setPortForApplicationStoryboard: (
    iframeId: string,
    port: MessagePort,
  ) => void;

  dragFinishedTrigger: number;
  setDragFinished: () => void;
}

export const useIframeStore = create<IframeStore>((set, get) => ({
  iframeMessagingPort: null,
  setIframeMessagingPort: (port: MessagePort | null) => {
    set({ iframeMessagingPort: port });
  },

  applicationStoryboardPorts: {},
  setPortForApplicationStoryboard: (iframeId: string, port: MessagePort) => {
    set((state) => ({
      applicationStoryboardPorts: {
        ...state.applicationStoryboardPorts,
        [iframeId]: port,
      },
    }));
  },
  dragFinishedTrigger: 0,
  setDragFinished: () => {
    set((state) => ({ dragFinishedTrigger: state.dragFinishedTrigger + 1 }));
  },
}));
